import React from "react";
import type { TNavItemConfig } from "@/types";
import { NavLink } from "react-router-dom";
import NavIcon from "@/components/navigation/navIcon";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";

interface IDesktopHeaderNavItemProps {
  item: TNavItemConfig;
  path?: string;
  onAction?: () => void;
  showDot?: boolean;
}

const DesktopHeaderNavItem: React.FC<IDesktopHeaderNavItemProps> = ({
  item,
  path,
  onAction,
  showDot = false,
}) => {
  const { t } = useTranslation();

  if (item.type === "action") {
    return (
      <Button
        type="button"
        variant="link"
        className="btn btn-link text-text-primary text-decoration-none p-0 d-flex flex-column align-items-center"
        onClick={onAction}
      >
        <div
          className="d-flex align-items-center justify-content-center lh-1 position-relative"
          style={{ height: 20 }}
        >
          <NavIcon iconKey={item.iconKey} variant="desktop" />
          {showDot ? (
            <span className="position-absolute top-0 start-100 translate-middle p-1 bg-primary border border-white rounded-circle" />
          ) : null}
        </div>
        <span className="fs-14 mt-1">{t(item.label)}</span>
      </Button>
    );
  }

  if (!path) {
    return (
      <span className="text-decoration-none d-flex flex-column align-items-center text-secondary opacity-50">
        <div
          className="d-flex align-items-center justify-content-center lh-1"
          style={{ height: 20 }}
        >
          <NavIcon iconKey={item.iconKey} variant="desktop" />
        </div>
        <span className="fs-14 mt-1">{t(item.label)}</span>
      </span>
    );
  }

  return (
    <NavLink
      to={path}
      end={item.key === "menu"}
      className={({ isActive }) =>
        `text-decoration-none d-flex flex-column align-items-center ${isActive ? "text-primary" : "text-text-primary"}`
      }
    >
      <div
        className="d-flex align-items-center justify-content-center lh-1"
        style={{ height: 20 }}
      >
        <NavIcon iconKey={item.iconKey} variant="desktop" />
      </div>
      <span className="fs-14 mt-1">{t(item.label)}</span>
    </NavLink>
  );
};

export default DesktopHeaderNavItem;
